export default "__VITE_ASSET__9e7338a4__"